export default {
  appTitle: 'RatesBoard - Dev',
  apiUrl: 'https://api.dev.ratesboard.com/api',
  appEnv: 'staging',
  useMockServices: false,
};
